<template>
  <div class="hiq-detail-planning-list__template-filter">
    <p class="hiq-detail-planning-list__template-filter-heading">
      {{ translations.filterByArea }}:
    </p>

    <ul
      id="area-filters"
      class="hiq-detail-planning-list__template-filter-list"
    >
      <Checkbox
        v-for="filter in areaFilter"
        :key="'area-' + filter.id"
        :filter="filter"
        group="areaFilter"
      />
    </ul>

    <p class="hiq-detail-planning-list__template-filter-heading">
      {{ translations.filterByStatus }}:
    </p>

    <ul
      id="status-filters"
      class="hiq-detail-planning-list__template-filter-list"
    >
      <Checkbox
        v-for="filter in statusFilter"
        :key="'status-' + filter.id"
        :filter="filter"
        group="statusFilter"
      />
    </ul>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { IFilter, ITranslations } from "../store/state";
import Checkbox from "./Checkbox.vue";
interface TemplateFiltersComputed {
  areaFilter: IFilter[];
  statusFilter: IFilter[];
  translations: ITranslations;
}
export default Vue.extend<{}, {}, TemplateFiltersComputed, {}>({
  name: "TemplateFilter",
  computed: {
    areaFilter() {
      return this.$store.getters.areaFilter;
    },

    statusFilter() {
      return this.$store.getters.statusFilter;
    },

    translations() {
      return this.$store.getters.translations;
    },
  },
  components: {
    Checkbox,
  },
});
</script>
